import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class AppErrorBoundaryInner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };

    this.handleBackToHome = this.handleBackToHome.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.handleGlobalError = this.handleGlobalError.bind(this);
    this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App route render failed', error, errorInfo);
  }

  componentDidMount() {
    window.addEventListener('error', this.handleGlobalError);
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.handleGlobalError);
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  handleReload() {
    window.location.reload();
  }

  handleBackToHome() {
    this.props.history.push('/');
  }

  handleGlobalError(event) {
    if (this.state.hasError || !event || !event.error) {
      return;
    }

    console.error('App global error caught', event.error);
    this.setState({ hasError: true });
  }

  handleUnhandledRejection(event) {
    if (this.state.hasError || !event || !event.reason) {
      return;
    }

    console.error('App unhandled rejection caught', event.reason);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="modal-error-wrapper app-error-boundary" role="alert" aria-live="assertive">
          <div className="modal-error-wrapper__content app-error-boundary__content">
            <div className="alert alert-danger alert-transparent">
              <h3 className="modal-error-wrapper__content--error-text">Oops!</h3>
              <p className="app-error-boundary__message">
                Something went wrong. Please try reloading the page. If the problem persists, please contact support.
              </p>
              <br />
              <br />
              <div className="app-error-boundary__actions">
                <button type="button" className="btn btn-purple btn-sm" onClick={this.handleBackToHome}>Back to Home</button>
                <button type="button" className="btn btn-purple btn-sm" onClick={this.handleReload}>Reload page</button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const AppErrorBoundary = ({ children, location, history }) => {
  const resetKey = `${location.pathname}${location.search}${location.hash}`;

  return <AppErrorBoundaryInner resetKey={resetKey} history={history}>{children}</AppErrorBoundaryInner>;
};

export default withRouter(AppErrorBoundary);